import { Component, Input, OnInit } from '@angular/core';
import { FilterOptionType } from 'src/app/library/enums/filters/filter.enum';
import { IFilter } from 'src/app/library/interfaces/filters/filter';
import { IFilterOption } from 'src/app/library/interfaces/filters/filter-option';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'filter-multi-select',
    templateUrl: './filter-multi-select.component.html',
    styleUrls: ['./filter-multi-select.component.scss']
})
export class FilterMultiSelectComponent implements OnInit {
    @Input() filter: IFilter;

    public dataTypeEnum = FilterOptionType;

    constructor(private filterService: FilterService) {}

    ngOnInit() {}

    public removeFilter() {
        this.filterService.removeFilter(this.filter);
        this.filterService.filterChangeEvent();
    }

    public selectOption(obj: IFilterOption) {
        let currentVal = this.filterService.filterConfig;
        let filterVal = currentVal.filters.find(
            e => e.field == this.filter.field
        );
        if (filterVal) {
            let optionVal = filterVal.options.find(e => e.value == obj.value);
            if (optionVal) {
                optionVal.isSelected = !optionVal.isSelected;
                this.filterService.filterConfig = currentVal;
                this.filterService.filterChangeEvent();
            }
        }
    }

    get selectedOptions() {
        return this.filter.options?.filter(e => e.isSelected);
    }

    get isMostRecentFilter() {
        return (
            this.filterService.mostRecentFilter()?.field == this.filter.field
        );
    }

    get addedFilterLength() {
        return this.filterService.filterConfig.filters.filter(e => e.added)
            .length;
    }
}
